import {
    video_persistent_player_update,
    video_persistent_player_null,
} from "./actions";

export const resetPersistentPlayerStatus = () => {
    return (dispatch) => {
        return dispatch(video_persistent_player_null());
    };
};

export const setPersistentPlayerStatus = ({
    isVisible,
    status,
    mediaItem,
    selector,
    routeUpdate,
    forcePersistence,
    sizeConfig,
    controlsConfig,
    mediaDataOverrides,
}) => {
    return (dispatch, getState) => {
        const currentPPState = getState().persistentPlayer;

        let newState = {
            isVisible:
                isVisible !== undefined ? isVisible : currentPPState.isVisible,
            mediaItem:
                mediaItem !== undefined ? mediaItem : currentPPState.mediaItem,
            selector:
                selector !== undefined ? selector : currentPPState.selector,
            routeUpdate:
                routeUpdate !== undefined
                    ? routeUpdate
                    : currentPPState.routeUpdate,
            forcePersistence:
                forcePersistence !== undefined
                    ? forcePersistence
                    : currentPPState.forcePersistence,
            status: status !== undefined ? status : currentPPState.status,
            sizeConfig:
                sizeConfig !== undefined
                    ? sizeConfig
                    : currentPPState.sizeConfig,
            controlsConfig: {
                hideFullscreenBtn: controlsConfig?.hideFullscreenBtn ?? false,
            },
            mediaDataOverrides:
                mediaDataOverrides !== undefined
                    ? mediaDataOverrides
                    : currentPPState.mediaDataOverrides,
        };

        return dispatch(video_persistent_player_update(newState));
    };
};
